type BackButtonEntry = { owner: symbol; handler: () => void };

const telegramBackButtonStack: BackButtonEntry[] = [];
let telegramBackButtonActiveHandler: (() => void) | null = null;

export const isTelegramBackButtonSupported = (): boolean => {
  const webApp = window.Telegram?.WebApp;
  if (!webApp?.BackButton) return false;
  // BackButton is not available in older Telegram WebApp versions (e.g. 6.0).
  if (typeof webApp.isVersionAtLeast === 'function') {
    return webApp.isVersionAtLeast('6.1');
  }
  return true;
};

export const isTelegramBackButtonActive = (): boolean => {
  if (!isTelegramBackButtonSupported()) return false;
  return telegramBackButtonStack.length > 0;
};

const removeBackButtonEntry = (owner: symbol) => {
  const index = telegramBackButtonStack.findIndex((entry) => entry.owner === owner);
  if (index !== -1) {
    telegramBackButtonStack.splice(index, 1);
  }
};

const syncBackButtonWithStack = () => {
  if (!isTelegramBackButtonSupported()) {
    telegramBackButtonActiveHandler = null;
    return;
  }
  const backButton = window.Telegram!.WebApp!.BackButton;
  if (!backButton) {
    return;
  }
  const activeEntry = telegramBackButtonStack[telegramBackButtonStack.length - 1];
  if (!activeEntry) {
    if (telegramBackButtonActiveHandler) {
      backButton.offClick(telegramBackButtonActiveHandler);
      telegramBackButtonActiveHandler = null;
    }
    backButton.hide();
    return;
  }
  backButton.show();
  if (telegramBackButtonActiveHandler && telegramBackButtonActiveHandler !== activeEntry.handler) {
    backButton.offClick(telegramBackButtonActiveHandler);
  }
  if (telegramBackButtonActiveHandler !== activeEntry.handler) {
    backButton.onClick(activeEntry.handler);
    telegramBackButtonActiveHandler = activeEntry.handler;
  }
};

export const addTelegramBackButtonEntry = (owner: symbol, handler: () => void) => {
  removeBackButtonEntry(owner);
  telegramBackButtonStack.push({ owner, handler });
  syncBackButtonWithStack();
};

export const removeTelegramBackButtonEntry = (owner: symbol) => {
  removeBackButtonEntry(owner);
  syncBackButtonWithStack();
};
